import React, { useRef, useEffect } from 'react';
import { observer } from 'mobx-react';
import { Row, Col, Container } from 'reactstrap';
import { Accordion } from 'cd-eft/components/common/Accordion';
import { ButtonBlock } from '../../common/ButtonBlock/ButtonBlock';
import { ActionsMenu } from '../../common/ActionsMenu';
import { UGOInputsVM } from './UGOInputsVM';
import { InputsElement } from '../../common/InputsElement';
import './UGOInputs.scss';
import stores from 'cd-eft/models/Stores';
import { useHistory, useParams } from 'react-router-dom';
import { Loader } from 'cd-eft/components/common/LoadingSpinner/LoadingSpinner';
import { PipeInputs } from '../UGOPipeInputs/UGOPipeInputs';

const { ugoDesignStore } = stores.AppStore;

const UGOInputsComponent = () => {
  const history = useHistory();
  const { ugoId }: any = useParams();

  const vmRef = useRef<UGOInputsVM | null>(null);
  if (!vmRef.current) {
    vmRef.current = new UGOInputsVM(history);
  }

  const vm = vmRef.current;

  const { UGOInfoSection, AlignmentSection } = vm.ugoInputsConfig;

  useEffect(() => {
    if (vm) {
      ugoDesignStore.ugoDesignObject.alignedElementDesignParamsId = +ugoId;
      vm.initializeDropdownInputsAndRestoreData();
      ugoDesignStore.ugoHistory = history
    }
  }, []);

  return (
    <>
      <Container>
        <Row>
          <Col xs="6">
            <Accordion
              className={'ugo-info accordion-wrapper'}
              headers={['Info']}
              waterwayWizardStatus={1}
              onClickInformationToggle={vm.onClickInformationToggle}
              light={true}
              iconPathQ={true}
            >
              <>
                {Object.entries(UGOInfoSection).map(([key, config]) => (
                  <InputsElement
                    key={'info-input-' + key}
                    config={config}
                    value={ugoDesignStore.inputForms['UGOInfoSection'][key]}
                    onChange={(e) => vm.handleInputsOnChange(e, 'UGOInfoSection')}
                    onBlur={(e) => vm.handleInputsOnBlur(e, 'UGOInfoSection')}
                    red={vm.redHighlighting['UGOInfoSection'][key]}
                  />
                ))}
              </>
            </Accordion>
          </Col>
          <Col xs="6">
            <Accordion
              className={'ugo-alignment accordion-wrapper'}
              headers={['Alignment']}
              waterwayWizardStatus={1}
              onClickInformationToggle={vm.onClickInformationToggle}
              light={true}
              iconPathQ={true}
            >
              <>
                {Object.entries(AlignmentSection).map(([key, config]) => (
                  <InputsElement
                    key={'alignment-input-' + key}
                    config={config}
                    value={ugoDesignStore.inputForms['AlignmentSection'][key]}
                    onChange={(e) => vm.handleInputsOnChange(e, 'AlignmentSection')}
                    onBlur={(e) => vm.handleInputsOnBlur(e, 'AlignmentSection')}
                    red={vm.redHighlighting['AlignmentSection'][key]}
                  />
                ))}
              </>
            </Accordion>
            <Accordion
              className={'ugo-pipeline-default accordion-wrapper'}
              headers={['Pipeline Default']}
              waterwayWizardStatus={1}
              directInformationPath='/ugomateriallist'
              light={true}
              iconPathQ={true}
            >
              <PipeInputs
                ugoInputsConfig={vm.ugoInputsConfig}
                inputForms={ugoDesignStore.inputForms}
                redHighlighting={vm.redHighlighting}
                canSetPressureFlow={vm.canSetPressureFlow}
                hasSectionChanged={vm.hasSectionChanged}
                formsValidation={vm.formsValidation}
              />
            </Accordion>
          </Col>
        </Row>
        <Row>
          <Col>
            <Accordion
              className={'ugo-comments accordion-wrapper'}
              headers={['Comments']}
              actionButton={<ActionsMenu i={'ugo-comments'} item="item" elementActions={vm.elementActions}>More</ActionsMenu>}
              light={true}
            >
              <>

              </>
            </Accordion>
          </Col>
        </Row>
      </Container>
      <ButtonBlock
        className='action-buttons'
        buttons={[
          { title: 'Close', disabled: false, onClick: () => { ugoDesignStore.handlecloseAction() }, className: 'usa-button--outline' },
          { title: 'Save', disabled: vm.disableSaveButton, onClick: () => { vm.onClickSave('save') } },
          { title: 'Save & Proceed', disabled: vm.disableSaveAndProceedButton, onClick: () => { vm.onClickSave('saveAndProceed') } },
        ]} />
      {vm.loading && <Loader message={''} />}
    </>
  );
}

export const UGOInputs = observer(UGOInputsComponent);